import React from 'react';
import { connect } from 'react-redux';

const NettWidgets = props => {
  const {
    rateType,
    retailNettMeasure,
    applyAll,
    onChangeForApplyAll,
    onChangeForProduct,
    nettDiffForAll,
    nettDiff,
    productId,
  } = props;
  const isPerentage = retailNettMeasure === 'percentage';
  return (
    <div style={{ marginLeft: '15%' }}>
      <span style={{ width: '10px', display: 'inline-block', color: '#009688', marginRight: '3px', fontSize: '16px' }}>{isPerentage ? '' : '$ '} </span>
      <input
        value={(applyAll ? nettDiffForAll : nettDiff) || ''}
        onChange={({ target: { value } }) => applyAll ? onChangeForApplyAll({ key: 'nettDiffForAll', value }) : onChangeForProduct({ productId, value, key: 'nettDiff' })}
        type="number"
        style={{ width: '70px', textAlign: 'right', fontSize: '25px', position: 'relative', top: '4px' }}
      />
      <span style={{ width: '10px', display: 'inline-block', color: '#009688', marginLeft: '5px', fontSize: '16px' }}>{isPerentage ? '%' : ''}</span>
    </div>
  );
};

const mapStateToProps = ({ contracting }) => ({
  rateType: contracting.massRateChange.get('rateType'),
  nettDiffForAll: contracting.massRateChange.getIn([contracting.massRateChange.get('updateType'), 'nettDiffForAll']),
  retailNettMeasure: contracting.massRateChange.getIn([contracting.massRateChange.get('updateType'), `${contracting.massRateChange.get('rateType')}Measure`]),
});

export default connect(mapStateToProps)(NettWidgets);



// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/middle-action-area/products/action-widgets/nett-widgets.jsx